export const SKIP_NAVIGATE = 'skip-navigate';